import { Noop } from 'types/common.interface';

import { StorePlatform } from 'enums/store-platform.enum';

import AppleStore from 'assets/icons/apple-store.png';
import ComingSoon from 'assets/icons/coming-soon.png';
import GooglePlay from 'assets/icons/google-play.png';
import Telegram from 'assets/icons/telegram.png';

import styles from './DownloadApp.module.scss';

interface IDownloadApp {
  platform: StorePlatform;
  customStoreUrl?: string;
  href?: string;
  onClick?: Noop;
  className?: string;
}

const DownloadApp = ({ platform, customStoreUrl, href, onClick, className = '' }: IDownloadApp) => {
  const renderContent = () => {
    switch (platform) {
      case StorePlatform.appleStore:
        return <img src={AppleStore} alt={platform} />;
      case StorePlatform.googlePlatform:
        return <img src={GooglePlay} alt={platform} />;
      case StorePlatform.telegram:
        return <img src={Telegram} alt={platform} className="tw-h-[35px] !tw-w-auto lg:tw-h-[52px]" />;
      case StorePlatform.comingSoon:
        return <img src={ComingSoon} alt={platform} className="tw-h-[35px] !tw-w-auto lg:tw-h-[52px]" />;
      default:
        return null;
    }
  };

  const finalHref = customStoreUrl || href || '#';
  const isComingSoon = platform === StorePlatform.comingSoon;

  return (
    <a
      className={`scale-in-hover ${className} ${styles['download-button']} ${isComingSoon ? styles['disabled'] : ''}`}
      target="_blank"
      rel="noreferrer"
      href={isComingSoon ? undefined : finalHref}
      onClick={isComingSoon ? undefined : onClick}
      style={isComingSoon ? { pointerEvents: 'none', cursor: 'default' } : {}}
    >
      {renderContent()}
    </a>
  );
};

export default DownloadApp;
